import * as Event from './EventComps';

type OnKeyType = 'Emit' | 'On';
type EmitKeysType = 'MobileRoute';

interface EventBusComps {
  MobileRouteEmit?: any;
  MobileRouteOn?: any;
}

// emitKeys为事件名
const emitKeys: EmitKeysType[] = ['MobileRoute'];
// Emit组件是传递，On组件是接收
const onKeys: OnKeyType[] = ['Emit', 'On'];

// 所有的组件
const Comps: EventBusComps = {};

onKeys.forEach((el: OnKeyType) => {
  const Comp = Event[`Event${el}`];

  emitKeys.forEach((item: EmitKeysType) => {
    const Node = (props: any) => {
      return <Comp eventKey={item} {...props} />;
    };
    Comps[`${item}${el}`] = Node;
  });
});

export const EventBus = { ...Comps };
